import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import AdminAudioToggle from "@/components/admin/AdminAudioToggle";

/** Mismo selector de sonido del Back Office, guardado por cada usuario del panel. */
export default function PanelAudioToggle() {
  const [uid, setUid] = useState<string | null>(null);
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setUid(data.session?.user.id ?? "guest"));
  }, []);
  if (!uid) return null;
  return <AdminAudioToggle variant="panel" scopeKey={`rl-panel-audio-${uid}`} />;
}
